import React from "react";

const Notify = () => {
    return (
        <>
        </>
    )
}
export default Notify;